export enum TAB_VARIANTS {
    FILLED = 'filled',
    UNDERLINE = 'underline',
}
